import {AccountApiDto} from "../../api/model/rest";
import {option, Option} from "ts-option";

export default class Account {

	constructor(public readonly id: string,
		public readonly name: string,
		public readonly code: string,
		public readonly description: Option<string>,
		public readonly balance: number,
		public readonly taxType: string,
		public readonly type: string,
		public readonly availableForUser: boolean) {}

	static fromJson(json: AccountApiDto): Account {
		return new Account(json.id, json.name, json.code, option(json.description), json.balance, json.taxType, json.type,
			json.availableForUser);
	}
}

export enum TaxType {
	Vat = "VAT",
	NoVat = "NO_VAT"
}

export enum AccountType {
	Bank = "BANK",
	Revenue = "REVENUE",
	DirectCosts = "DIRECT_COSTS",
	CurrentAsset = "CURRENT_ASSET",
	CurrentLiability = "CURRENT_LIABILITY",
	NonCurrentLiability = "NON_CURRENT_LIABILITY"
}
